import axios from "axios";
import API_RESOURCES from "constants/service-resources";
import IConsultaMetaForm from "interfaces/app/IConsultaMetaForm";
import IFromToFilter from "interfaces/app/IFromToFilter";
import IResumenDesempeno from "interfaces/service/models/IResumenDesempeno";
import IResumenDesempeVisitador from "interfaces/service/models/IResumenDesempVisitador";
import IResumenMetaVisitadorMes from "interfaces/service/models/IResumenMetaVisitadorMes";
import IDesempProductosRequest from "interfaces/service/requests/IDesempProductosRequest";
import IMetaMesRequest from "interfaces/service/requests/IMetaMesRequest";
import IRendimientoVisitadoresMensualRequest from "interfaces/service/requests/IRendimientoVisitadoresMensualRequest";
import IRendimientoVisitadoresRequest from "interfaces/service/requests/IRendimientoVisitadoresRequest";
import IRendimientoVisitadorRequest from "interfaces/service/requests/IRendimientoVisitadorRequest";
import IresumenMensualResponse from "interfaces/service/responses/IresumenMensualResponse";
import IVisitasMedicoEspecialidadResponse from "interfaces/service/responses/IVisitasMedicoEspecialidad";
import IEstadistica from '../interfaces/service/models/IEstadistica'
import IVisitaMedico from '../interfaces/service/models/IVisitaMedico'
import IVisitaCliente from '../interfaces/service/models/IVisitaCliente'
import { IVisitasMedicasRequest } from '../pages/tareas/estadisticas/visitas-medicas/page'
import { IVisitasClientesRequest } from '../pages/tareas/estadisticas/visitas-clientes/page'

export async function desempProductos(data: IDesempProductosRequest) {
    const result = await axios.get<IResumenDesempeno[]>(API_RESOURCES.ESTADISTICAS.BASE + '/productos', {
        params: {
            ...data
        }
    })
    return result.data
}

export async function rendimientoVisitadores(data: IRendimientoVisitadoresRequest) {
    const result = await axios.get<IResumenDesempeno[]>(API_RESOURCES.ESTADISTICAS.BASE + '/rendimiento-visitadores', {
        params: {
            ...data
        }
    })
    return result.data
}

export async function rendimientoVisitadoresMensual(data: IRendimientoVisitadoresMensualRequest) {
    const result = await axios.get<IresumenMensualResponse[]>(API_RESOURCES.ESTADISTICAS.BASE + '/rendimiento-visitadores/por-mes', {
        params: {
            ...data
        }
    })
    return result.data
}

export async function rendimientoVisitador(data: IRendimientoVisitadorRequest) {
    const result = await axios.get<IResumenDesempeVisitador>(API_RESOURCES.ESTADISTICAS.BASE + '/rendimiento-visitador', {
        params: {
            ...data
        }
    })
    return result.data
}

export async function acciones(data: IFromToFilter) {
    const result = await axios.get<IResumenDesempeno[]>(API_RESOURCES.ESTADISTICAS.BASE + '/acciones', {
        params: {
            ...data
        }
    })
    return result.data
}

export async function metasMes(data: IConsultaMetaForm) {
    const metaMesRequest: IMetaMesRequest = {
        mes: data.mesAno.getMonth() + 1,
        ano: data.mesAno.getFullYear()
    }
    const result = await axios.get<IResumenMetaVisitadorMes[]>(API_RESOURCES.ESTADISTICAS.BASE + '/metas', {
        params: {
            ...metaMesRequest
        }
    })
    
    return result.data
}

export async function visiasMedicosPorEspecialdad(data: IDesempProductosRequest) {
    const result = await axios.get<IVisitasMedicoEspecialidadResponse[]>(API_RESOURCES.ESTADISTICAS.BASE + '/medicos-especialidad', {
        params: {
            ...data
        }
    })
    return result.data
}

export async function getVisitasMedicas(data: IVisitasMedicasRequest) {
    try {
        console.log('Enviando petición a:', API_RESOURCES.ESTADISTICAS.BASE + '/visitas-medicas', 'con datos:', data);
        const result = await axios.get<IVisitaMedico[]>(API_RESOURCES.ESTADISTICAS.BASE + '/visitas-medicas', {
            params: {
                ...data
            },
            withCredentials: true,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        console.log('Respuesta recibida:', result.data);
        return result.data;
    } catch (error) {
        console.error('Error en getVisitasMedicas:', error);
        throw error;
    }
}

export async function exportVisitasMedicas(data: IVisitasMedicasRequest) {
    try {
        console.log('Enviando petición de exportación a:', API_RESOURCES.ESTADISTICAS.BASE + '/visitas-medicas/export', 'con datos:', data);
        const result = await axios({
            method: 'get',
            url: API_RESOURCES.ESTADISTICAS.BASE + '/visitas-medicas/export',
            params: {
                ...data
            },
            withCredentials: true,
            responseType: 'blob',
            headers: {
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Content-Type': 'application/json'
            }
        });
        return result;
    } catch (error) {
        console.error('Error en exportVisitasMedicas:', error);
        throw error;
    }
}

export async function exportMisVisitasMedicas(data: IVisitasMedicasRequest) {
    try {
        console.log('Enviando petición de exportación a:', API_RESOURCES.ESTADISTICAS.BASE + '/mis-visitas-medicas/export', 'con datos:', data);
        const result = await axios({
            method: 'get',
            url: API_RESOURCES.ESTADISTICAS.BASE + '/mis-visitas-medicas/export',
            params: {
                ...data
            },
            withCredentials: true,
            responseType: 'blob',
            headers: {
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Content-Type': 'application/json'
            }
        });
        return result;
    } catch (error) {
        console.error('Error en exportMisVisitasMedicas:', error);
        throw error;
    }
}

export async function getVisitasClientes(data: IVisitasClientesRequest) {
    try {
        console.log('Enviando petición a:', API_RESOURCES.ESTADISTICAS.BASE + '/visitas-clientes', 'con datos:', data);
        const result = await axios.get<IVisitaCliente[]>(API_RESOURCES.ESTADISTICAS.BASE + '/visitas-clientes', {
            params: {
                ...data
            },
            withCredentials: true,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        console.log('Respuesta recibida de visitas a clientes:', result.data);
        return result.data;
    } catch (error) {
        console.error('Error en getVisitasClientes:', error);
        throw error;
    }
}

export async function enviarAlertaMedicosBajoPorcentaje(
    data: Pick<IDesempProductosRequest, 'from' | 'to' | 'visitador_id'>
) {
    try {
        console.log(
            'Enviando alerta de médicos bajo porcentaje a:',
            API_RESOURCES.ESTADISTICAS.BASE + '/visitas-medicas/alerta-bajo-porcentaje',
            'con datos:',
            data
        );

        const result = await axios.post(
            API_RESOURCES.ESTADISTICAS.BASE + '/visitas-medicas/alerta-bajo-porcentaje',
            {
                ...data,
            },
            {
                withCredentials: true,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        return result.data;
    } catch (error) {
        console.error('Error en enviarAlertaMedicosBajoPorcentaje:', error);
        throw error;
    }
}